var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"captcha"},[_c('canvas',{ref:"captchaCanvas",attrs:{"width":_vm.width,"height":_vm.height},on:{"click":_vm.refreshCaptcha}})])
}
var staticRenderFns = []

export { render, staticRenderFns }